import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import { Dropdown, Form, Modal } from "react-bootstrap";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Resizer from "react-image-file-resizer";
import { connect } from "react-redux";
import {
  toastError,
  toastSuccess,
  countryActionId,
  cityActionId,
  industryActionId,
  stateActionId,
  DOC_BASE_URL,
  businessSectorActionId,
  exportMarketsActionId,
  gstValidationListActionId,
  primaryServicesActionId,
  documentsListActionId,
  sessionExpireMessage,
  tokenInavlidMessage,
} from "../../../utils/constants";
import { fill_action } from "../../../actions/fillCombo_action";
import {
  emailValidator,
  panNoValidator,
  gstNoValidator,
} from "../../../utils/Validator";
import Header from "../../../common_components/Header";
import {
  get_userDetails_action,
  updateMemberDetails_action,
} from "../../../actions/adminAction/users_action";
import Loader from "../../../utils/Loader";
import {
  checkAvailableUsername_action,
  deleteRegistrationDocument_action,
} from "../../../actions/staticAction/registration_action";

class userDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOtherPreName: false,
      viewMode: "",
      MemberId: "",
      MembershipNo: "",
      prename: "Mr",
      otherName: "",
      companyName: "",
      companywebsite: "",
      industryId: "",
      yearOfEstablishment: "",
      companyAdd1: "",
      companyAdd2: "",
      city: "",
      regstate: "",
      countryId: "",
      contactPerson: "",
      designation: "",
      emailId: "",
      phone: "",
      prephone: "",
      stateId: "",

      sameAsCorrespondence: false,
      isOpenDropDownState: false,
      focusedIndexState: -1,
      isOpenDropDownCity: false,
      focusedIndexCity: -1,
      invisOpenDropDownState: false,
      invfocusedIndexState: -1,
      invisOpenDropDownCity: false,
      invfocusedIndexCity: -1,
      tempCityList: [],
      tempStateList: [],
      cityList: [],
      stateList: [],
      countryList: [],
      industryList: [],
      invisOtherPreName: false,
      invprename: "Mr",
      invotherName: "",
      invcompanyName: "",
      invcompanywebsite: "",
      invindustryId: "",
      invyearOfEstablishment: "",
      invcompanyAdd1: "",
      invcompanyAdd2: "",
      invcity: "",
      invregstate: "",
      invcountryId: "",
      invcontactPerson: "",
      invdesignation: "",
      invemailId: "",
      invphone: "",
      invprephone: "",
      AccountID: "",
      namePrefix: ["Mr", "Ms", "DR", "Prof"],
      businessList: [],
      productsList: [],
      exportsList: [],
      docTypeList: [],
      annualRevenue: "",
      documentsList: [],
      // ERROR
      companyNameErr: "",
      companywebsiteErr: "",
      industryIdErr: "",
      yearOfEstablishmentErr: "",
      companyAdd1Err: "",
      companyAdd2Err: "",
      cityErr: "",
      regstateErr: "",
      countryIdErr: "",
      contactPersonErr: "",
      designationErr: "",
      emailIdErr: "",
      phoneErr: "",

      invcompanyNameErr: "",
      invcompanywebsiteErr: "",
      invindustryIdErr: "",
      invyearOfEstablishmentErr: "",
      invcompanyAdd1Err: "",
      invcompanyAdd2Err: "",
      invcityErr: "",
      invregstateErr: "",
      invcountryIdErr: "",
      invcontactPersonErr: "",
      invdesignationErr: "",
      invemailIdErr: "",
      invphoneErr: "",
      //business
      isOpen: false,
      AccountID: "",
      businessList: [],
      productsList: [],
      exportsList: [],
      annualRevenue: "",
      documentsList: [],
      docTypeList: [],
      GstNoErr: "",
      PanNoErr: "",
      gstValidationList: [],
      GstdocErr: "",
      PandocErr: "",
      docsErr: "",
      docDeleteID: "",
      primaryProduct: "",
      primaryProductsErr: "",
      businessListErr: "",
      otherBusiness: "",
      otherPrimaryProduct: "",
      otherBusinessErr: "",
      otherPrimaryProductErr: "",
    
    };
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
      setTimeout(() => {
        this.props.navigate("/");
      }, 200);
    } else {
      window.scrollTo(0, 0);
      sessionStorage.setItem("currentPage", "admin-user");
      this.getFillList(countryActionId, "", "", "", "").then(() => {
        this.getFillList(industryActionId, "", "", "", "").then(() => {
          this.getFillList(documentsListActionId, "", "", "", "").then(() => {
            this.getFillList(businessSectorActionId, "", "", "", "").then(
              () => {
                this.getFillList(exportMarketsActionId, "", "", "", "").then(
                  () => {
                    this.getFillList(
                      primaryServicesActionId,
                      "",
                      "",
                      "",
                      ""
                    ).then(() => {
                      this.getFillList(
                        gstValidationListActionId,
                        "",
                        "",
                        "",
                        ""
                      ).then(() => {
                        if (sessionStorage.getItem("RoleIDSS") == 5) {
                          this.setState(
                            {
                              MemberId: sessionStorage.getItem("MemberIDSS"),
                              viewMode: 0,
                            },
                            () => {
                              this.getDetails(
                                sessionStorage.getItem("MemberIDSS")
                              );
                            }
                          );
                        } else {
                          this.setState(
                            {
                              MemberId: this.props?.location?.state?.MemberId,
                              viewMode:
                                this.props?.location?.state?.Mode == "view"
                                  ? 1
                                  : 0,
                            },
                            () => {
                              if (
                                this.props?.location?.state?.MemberId != null
                              ) {
                                console.log(sessionStorage.getItem("RoleIDSS"));
                                this.getDetails(
                                  this.props?.location?.state?.MemberId
                                );
                              }
                            }
                          );
                        }
                      });
                    });
                  }
                );
              }
            );
          });
        });
      });
    }
  }

  getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
    this.setState({ isLoading: true });
    return new Promise((resolve) => {
      this.props
        .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
        .then((data) => {
          if (data.error != 1) {
            if (actionID === countryActionId) {
              this.setState({ countryList: data.data });
              resolve(true);
            }
            if (actionID === stateActionId) {
              data.data.length > 0 &&
                this.setState({
                  stateList: data.data,
                  tempStateList: data.data,
                });
              resolve(true);
            }
            if (actionID === cityActionId) {
              data.data.length > 0 &&
                this.setState({
                  cityList: data.data,
                  tempCityList: data.data,
                });
              resolve(true);
            }
            if (actionID === industryActionId) {
              this.setState({
                industryList: data.data,
                // tempCityList: data.data,
              });
              resolve(true);
            }
            if (actionID === businessSectorActionId) {
              data.data.length > 0 &&
                data.data.forEach((item) => {
                  item.isSelect = false;
                });
              this.setState(
                { businessList: data.data },
                () => console.log(data.data),
                resolve(true)
              );
            }
            if (actionID === exportMarketsActionId) {
              data.data.length > 0 &&
                data.data.forEach((item) => {
                  item.isSelect = false;
                });
              this.setState(
                {
                  exportsList: data.data,
                },
                () => resolve(true)
              );
            }
            if (actionID === gstValidationListActionId) {
              this.setState(
                {
                  gstValidationList: data.data,
                },
                () => resolve(true)
              );
            }
            if (actionID === primaryServicesActionId) {
              data.data.length > 0 &&
                data.data.forEach((item) => {
                  item.isSelect = false;
                });
              this.setState(
                {
                  productsList: data.data,
                },
                () => resolve(true)
              );
            }
            if (actionID === documentsListActionId) {
              console.log(data.data);
              this.setState({ docTypeList: data.data }, () => resolve(true));
            }
          } else {
            this.setState({ isLoading: false });
          }
        });
    });
  }
  validateEmail = (email) => {
    if (!email) return "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) ? "" : "Invalid Email";
  };

 
  getDetails(MemberId) {
    const { namePrefix, businessList, productsList, exportsList } = this.state;
    this.setState({ isLoading: true });
    this.props.get_userDetails_action(MemberId).then((data) => {
      console.log(data);
      if (data.error != 1) {
        // console.log(data.data.MemberId)
        const companyData = data.data?.[0];
        const docsData = data.data?.[1][0];
        const businessData = data.data?.[2];
        // const productData = data.data?.[3];
        const exportData = data.data?.[3];
       
        //company
        var phn = companyData?.[0]?.["PhoneNumber"];
        const parts = phn != "" ? phn.split("-") : "";
        const Mob1Code = parts.length > 1 && parts != "" ? parts[0] : "";
        const Mob1No =
          parts != "" ? (parts.length > 1 ? parts[1] : parts[0]) : "";
        var invPhn = companyData?.[0]?.["INVPhoneNumber"];
        const parts3 = invPhn != "" ? invPhn.split("-") : "";
        const invMob1Code = parts3.length > 1 && parts3 != "" ? parts3[0] : "";
        const invMob1No =
          parts3 != "" ? (parts3.length > 1 ? parts3[1] : parts3[0]) : "";

        if (companyData[0].CountryID == 91) {
          this.getFillList(
            stateActionId,
            "",
            companyData?.[0]?.CountryID,
            "",
            ""
          );
          this.getFillList(
            cityActionId,
            "",
            companyData?.[0]?.CountryID,
            "",
            ""
          );
        }
        this.setState({
          prename: namePrefix.includes(companyData?.[0]?.["Title"])
            ? companyData?.[0]?.["Title"]
            : "Other",
          isOtherPreName: namePrefix.includes(companyData?.[0]?.["Title"])
            ? false
            : true,
          otherName: namePrefix.includes(companyData?.[0]?.["Title"])
            ? ""
            : companyData?.[0]?.["Title"],
          invprename: namePrefix.includes(companyData?.[0]?.["INVTitle"])
            ? companyData?.[0]?.["INVTitle"]
            : "Other",
          invisOtherPreName: namePrefix.includes(companyData?.[0]?.["INVTitle"])
            ? false
            : true,
          invotherName: namePrefix.includes(companyData?.[0]?.["INVTitle"])
            ? ""
            : companyData?.[0]?.["INVTitle"],
          prephone: Mob1Code,
          phone: Mob1No,
          invprephone: invMob1Code,
          invphone: invMob1No,
          MemberID: companyData?.[0]?.MemberID,
          MembershipNo: companyData?.[0]?.MembershipNo,
          companyName: companyData?.[0]?.CompanyName,
          companywebsite: companyData?.[0]?.CompanyWebsite,
          industryId: companyData?.[0]?.IndustryID,
          yearOfEstablishment: companyData?.[0]?.EstablishmentYear,
          companyAdd1: companyData?.[0]?.Address1,
          companyAdd2: companyData?.[0]?.Address2,
          city: companyData?.[0]?.City,
          regstate: companyData?.[0]?.State,
          countryId: companyData?.[0]?.CountryID,
          contactPerson: companyData?.[0]?.ContactPersonName,
          designation: companyData?.[0]?.ContactPersonDesignation,
          emailId: companyData?.[0]?.EmailAddress,
          sameAsCorrespondence: companyData?.[0]?.SameAsCorrespondance,
          invcompanyName: companyData?.[0]?.INVCompanyName,
          invcompanywebsite: companyData?.[0]?.INVCompanyWebsite,
          invindustryId: companyData?.[0]?.INVIndustryID,
          invyearOfEstablishment: companyData?.[0]?.INVEstablishmentYear,
          invcompanyAdd1: companyData?.[0]?.INVAddress1,
          invcompanyAdd2: companyData?.[0]?.INVAddress2,
          invcity: companyData?.[0]?.INVCity,
          invregstate: companyData?.[0]?.INVState,
          invcountryId: companyData?.[0]?.INVCountryID,
          invcontactPerson: companyData?.[0]?.INVContactPersonName,
          invdesignation: companyData?.[0]?.INVContactPersonDesignation,
          invemailId: companyData?.[0]?.INVEmailAddress,
        });
        //business
        // if (docsData.MembershipFormStatusID == 1) {
        // } else {
        if (
          (docsData["GSTFilePath"] && docsData["GSTFilePath"] !== "") ||
          (docsData["GSTNo"] && docsData["GSTNo"] !== "")
        ) {
          let filePath = docsData["GSTFilePath"] || "";
          let array = filePath ? filePath.split("/") : [];
          let FileName = array.length > 0 ? array[array.length - 1] : "";
          for (let i = 0; i < this.state.docTypeList.length; i++) {
            if (this.state.docTypeList[i].Code == 1) {
              this.state.documentsList.push({
                docId: this.state.docTypeList[i].Code,
                fileName: FileName,
                fileType: "",
                filePath: filePath,
                file: FileName,
                no: docsData.GSTNo || "",
                type: this.state.docTypeList[i].Description,
              });
            }
          }
        }

        // PAN Document
        if (
          (docsData["PanCardFilePath"] && docsData["PanCardFilePath"] !== "") ||
          (docsData["PanNo"] && docsData["PanNo"] !== "")
        ) {
          let filePath = docsData["PanCardFilePath"] || "";
          let array = filePath ? filePath.split("/") : [];
          let FileName = array.length > 0 ? array[array.length - 1] : "";
          for (let i = 0; i < this.state.docTypeList.length; i++) {
            if (this.state.docTypeList[i].Code == 2) {
              this.state.documentsList.push({
                docId: this.state.docTypeList[i].Code,
                fileName: FileName,
                fileType: "",
                filePath: filePath,
                file: FileName,
                no: docsData.PanNo || "",
                type: this.state.docTypeList[i].Description,
              });
            }
          }
        }

        // Additional Document
        if (
          docsData["AdditionalDocumentFilePath"] &&
          docsData["AdditionalDocumentFilePath"] !== ""
        ) {
          let filePath = docsData["AdditionalDocumentFilePath"];
          let array = filePath ? filePath.split("/") : [];
          let FileName = array.length > 0 ? array[array.length - 1] : "";
          for (let i = 0; i < this.state.docTypeList.length; i++) {
            if (this.state.docTypeList[i].Code == 3) {
              this.state.documentsList.push({
                docId: this.state.docTypeList[i].Code,
                fileName: FileName,
                fileType: "",
                filePath: filePath,
                file: FileName,
                no: "",
                type: this.state.docTypeList[i].Description,
              });
            }
          }
        }
        // }
        if (this.state.documentsList.length == 0) {
          if (parseInt(sessionStorage.getItem("countryId")) == 91) {
            for (var i = 0; i < this.state.docTypeList.length; i++) {
              console.log(this.state.docTypeList[i]);
              if (
                this.state.docTypeList[i].Code == 1 ||
                this.state.docTypeList[i].Code == 2
              ) {
                this.state.documentsList.push({
                  docId: this.state.docTypeList[i].Code,
                  fileName: "",
                  fileType: "",
                  filePath: "",
                  file: "",
                  no: "",
                  type: this.state.docTypeList[i].Description,
                });
              }
            }
          } else {
            this.state.documentsList.push({
              docId: "",
              fileName: "",
              fileType: "",
              filePath: "",
              file: "",
              no: "",
              type: "",
            });
          }
        }
        console.log(this.state.documentsList);

        var businessListDetails = businessData.length > 0 ? businessData : [];
        for (var i = 0; i < businessList.length; i++) {
          for (var j = 0; j < businessListDetails.length; j++) {
            if (
              businessList[i].Code == businessListDetails[j].BusinessSectorID
            ) {
              businessList[i].isSelect = true;
              if (businessList[i].Code == 14) {
                this.setState({ otherBusiness: docsData.OtherBusinessSector });
              }
            }
          }
        }
        // var productsListDetails = productData.length > 0 ? productData : []
        // for (var i = 0; i < productsList.length; i++) {
        //     for (var j = 0; j < productsListDetails.length; j++) {
        //         if (productsList[i].Code == productsListDetails[j].PrimaryServicesID) {
        //             productsList[i].isSelect = true
        //             if (productsList[i].Code == 6) {
        //                 this.setState({ otherPrimaryProduct: docsData.OtherPrimaryServices })
        //             }
        //         }
        //     }
        // }
        var exportsListDetails = exportData.length > 0 ? exportData : [];
        for (var i = 0; i < exportsList.length; i++) {
          for (var j = 0; j < exportsListDetails.length; j++) {
            if (exportsList[i].Code == exportsListDetails[j].ExportMarketsID) {
              exportsList[i].isSelect = true;
            }
          }
        }
        this.setState({
          MemberID: docsData.MemberID,
          MembershipNo: docsData.MembershipNo,
          annualRevenue: docsData.AnnualRevenue,
          exportsList: exportsList,
          productsList: productsList,
          businessList: businessList,
          documentsList: this.state.documentsList,
          primaryProduct: docsData.PrimaryServices,
        });
        this.setState({ isLoading: false });
      } else {
        this.setState({ isLoading: false });
        toastError(data.data.ErrorMsg);
        if (
          data.msg == sessionExpireMessage ||
          data.msg == tokenInavlidMessage
        ) {
          //after session expire.....................
          sessionStorage.clear();
          this.props.navigate("/");
          setTimeout(() => {
            toastError(data.msg);
          }, 2000);
        } else {
          toastError(data.data);
        }
      }
    });
  }
  onbusinessSelect(id) {
    const { businessList } = this.state;
    console.log(id);
    for (var i = 0; i < businessList.length; i++) {
      if (businessList[i].Code == id) {
        if (businessList[i].isSelect) {
          businessList[i].isSelect = false;
        } else {
          businessList[i].isSelect = true;
        }
      }
    }
    this.setState({ businessList: businessList, businessListErr: "" });
  }

  onProductSelect(id) {
    const { productsList } = this.state;
    console.log(id);
    for (var i = 0; i < productsList.length; i++) {
      if (productsList[i].Code == id) {
        if (productsList[i].isSelect) {
          productsList[i].isSelect = false;
        } else {
          productsList[i].isSelect = true;
        }
      }
    }
    this.setState({ productsList: productsList, primaryProductsErr: "" });
  }

  onExportsSelect(id) {
    const { exportsList } = this.state;
    console.log(id);
    for (var i = 0; i < exportsList.length; i++) {
      if (exportsList[i].Code == id) {
        if (exportsList[i].isSelect) {
          exportsList[i].isSelect = false;
        } else {
          exportsList[i].isSelect = true;
        }
      }
    }
    this.setState({ exportsList: exportsList });
  }

  onDocTypeSelect(id, Code) {
    console.log(Code);
    const { documentsList, docTypeList } = this.state;
    for (var j = 0; j < docTypeList.length; j++) {
      if (docTypeList[j].Code == Code) {
        documentsList[id].docId = Code;
        documentsList[id].type = docTypeList[j].Description;
      }
    }
    this.setState({ documentsList: documentsList }, () => {
      console.log(documentsList);
    });
  }
  onDocNoEnter(id, value, docId) {
    console.log(value);
    const { documentsList, gstValidationList } = this.state;
    const stateId = parseInt(sessionStorage.getItem("stateId"));

    let gstError = "",
      panError = "";

    if (docId === 1) {
      // GST Validation
      if (value.length >= 2) {
        const code = value.slice(0, 2);
        const matchedState = gstValidationList.find(
          (item) => item.StateID === stateId
        );

        if (matchedState) {
          const errMsg = gstNoValidator(value);
          if (errMsg) {
            gstError = "Please enter a proper GST number";
          } else if (parseInt(matchedState.GSTCode) !== parseInt(code)) {
            gstError = "GST number state code does not match";
          }
        }
      } else {
        gstError = "GST number is too short";
      }
    }

    if (docId === 2) {
      // PAN Validation
      panError = panNoValidator(value) || "";
    }

    // Update state with errors & document list
    this.setState((prevState) => ({
      GstNoErr: gstError,
      PanNoErr: panError,
      documentsList: prevState.documentsList.map((doc, index) =>
        index === id ? { ...doc, no: value } : doc
      ),
    }));
  }

  // On File Pick
  onFilePick = async (e, file, id, docId) => {
    e.preventDefault();
    const { documentsList } = this.state;
    console.log("File01010101------", file);
    if (file.length != 0) {
      if (file[0]["size"] >= 5 * 1024 * 1024) {
        toastError("File size more than 5mb are not allow.");
      } else {
        var image = "";
        if (
          file[0]["name"].toString().toLowerCase().includes(".pdf") ||
          file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
          file[0]["name"].toString().toLowerCase().includes(".png") ||
          file[0]["name"].toString().toLowerCase().includes(".jpg")
        ) {
          if (
            file[0]["name"].toString().toLowerCase().trim().includes(".jpg") ||
            file[0]["name"].toString().toLowerCase().trim().includes(".png") ||
            file[0]["name"].toString().toLowerCase().trim().includes(".jpeg")
          ) {
            image = await this.resizeFile(file[0]);
            for (var i = 0; i < documentsList.length; i++) {
              if (i == id) {
                documentsList[i].file = image;
                documentsList[i].fileName = file[0]["name"].toString();
              }
            }
            this.setState({ documentsList: documentsList });
          } else if (
            file[0]["name"].toString().toLowerCase().trim().includes(".pdf")
          ) {
            image = await this.onPdfSelect(file[0]);
            for (var i = 0; i < documentsList.length; i++) {
              if (i == id) {
                documentsList[i].file = image;
                documentsList[i].fileName = file[0]["name"].toString();
              }
            }
            this.setState({ documentsList: documentsList });
          }
          var fileType = file[0]["type"];
          var fileTypeList;
          if (fileType.includes("/")) {
            fileTypeList = fileType.split("/");
          }
          for (var i = 0; i < documentsList.length; i++) {
            if (i == id) {
              documentsList[i].fileType =
                fileTypeList.length > 0 ? fileTypeList[1] : "";
            }
          }
          this.setState({ documentsList: documentsList });
          if (docId == 1) {
            this.setState({ GstdocErr: "" });
          } else if (docId == 2) {
            this.setState({ PandocErr: "" });
          }
        } else {
          toastError("Only .pdf , .jpeg, .png, .jpg files are allowed");
          for (var i = 0; i < documentsList.length; i++) {
            if (i == id) {
              documentsList[i].file = "";
              documentsList[i].fileType = "";
              documentsList[i].fileName = "";
              documentsList[i].filePath = "";
              document.getElementById(`file${id}`).value = "";
            }
          }
        }
      }
    }
  };

  // If Pdf is selected in file
  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  // File resize
  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        "JPEG",
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300
      );
    });

  onAddRow() {
    this.state.documentsList.push({
      docId: "",
      fileName: "",
      fileType: "",
      filePath: "",
      file: "",
      no: "",
      type: "",
    });
    this.setState({ documentsList: this.state.documentsList });
  }
  onDelRow(i) {
    this.state.documentsList.splice(i, 1);
    this.setState({ documentsList: this.state.documentsList });
  }

  handleDeleteDocument(e) {
    e.preventDefault();
    const { docDeleteID, documentsList, MemberID } = this.state;
    this.setState({ isLoading: true });

    // sessionStorage.getItem('VisitorTypeID') == 1 && this.setState({ passportFile: "", passPortFileName: "", isPassportFilePresent: false })
    for (var i = 0; i < documentsList.length; i++) {
      if (documentsList[i].docId == docDeleteID) {
        documentsList[i].file = "";
        documentsList[i].fileType = "";
        documentsList[i].fileName = "";
        documentsList[i].filePath = "";
      }
    }
    this.setState({
      isLoading: false,
      documentsList: documentsList,
      isOpen: false,
    });
    toastSuccess("Document Deleted SuccessFully");
    // sessionStorage.getItem('VisitorTypeID') == 2 && this.setState({ visitorGroupList: visitorGroupList })
    // this.getVisitorRegistrationDetails()
  }

  onCrossClick(id) {
    console.log("id", id);
    this.setState({
      docDeleteID: id,
      isOpen: true,
    });
  }
  updateMemberDetail() {
    const {
      companyName,
      companywebsite,
      industryId,
      yearOfEstablishment,
      companyAdd1,
      companyAdd2,
      city,
      regstate,
      countryId,
      contactPerson,
      designation,
      emailId,
      phone,
      sameAsCorrespondence,
      invcompanyName,
      invcompanywebsite,
      invindustryId,
      invyearOfEstablishment,
      invcompanyAdd1,
      invcompanyAdd2,
      invcity,
      invregstate,
      invcountryId,
      invcontactPerson,
      invdesignation,
      invemailId,
      invphone,
      prename,
      isOtherPreName,
      otherName,
      invisOtherPreName,
      invotherName,
      invprename,
      prephone,
      invprephone,
      stateList,
      MemberId,
      MembershipNo,
      otherBusiness,
      otherPrimaryProduct,
      annualRevenue,
      documentsList,
      primaryProduct,
    } = this.state;
    this.inputValidation().then((res) => {
      var stateErr = true;
      var stateID = null;
      if (countryId == 91) {
        for (var i = 0; i < stateList.length; i++) {
          if (
            this.state.regstate.toLowerCase() ==
            stateList[i].Description.toLowerCase()
          ) {
            stateErr = false;
            stateID = stateList[i].Code;
          }
        }
      } else {
        stateErr = false;
      }
      var GSTno = "";
      var PANno = "";
      for (var i = 0; i < this.state.documentsList.length; i++) {
        if (
          this.state.documentsList[i].docId == 1 &&
          this.state.documentsList[i].no != ""
        ) {
          GSTno = this.state.documentsList[i].no;
        }
        if (
          this.state.documentsList[i].docId == 2 &&
          this.state.documentsList[i].no != ""
        ) {
          PANno = this.state.documentsList[i].no;
        }
      }

      var finalbusinessList = [];
      for (var i = 0; i < this.state.businessList.length; i++) {
        if (this.state.businessList[i].isSelect) {
          finalbusinessList.push({
            BuisnessSectorID: this.state.businessList[i].Code,
          });
        }
      }

      var finalproductsList = [];
      for (var i = 0; i < this.state.productsList.length; i++) {
        if (this.state.productsList[i].isSelect) {
          finalproductsList.push({
            PrimaryServicesID: this.state.productsList[i].Code,
          });
        }
      }

      var finalexportsList = [];
      for (var i = 0; i < this.state.exportsList.length; i++) {
        if (this.state.exportsList[i].isSelect) {
          finalexportsList.push({
            ExportMarketsID: this.state.exportsList[i].Code,
          });
        }
      }
      if (!res) {
        if (!stateErr) {
          this.setState({ isLoading: true });
          
          this.props
            .updateMemberDetails_action(
              MemberId,
              MembershipNo,
              companyName,
              companywebsite,
              industryId,
              yearOfEstablishment,
              companyAdd1,
              companyAdd2,
              city,
              regstate,
              countryId,
              isOtherPreName ? otherName : prename,
              contactPerson,
              designation,
              emailId,
              prephone != null && prephone != ""
                ? `${prephone}-${phone}`
                : phone,
              sameAsCorrespondence,
              invcompanyName,
              invcompanywebsite,
              invindustryId,
              invyearOfEstablishment,
              invcompanyAdd1,
              invcompanyAdd2,
              invcity,
              invregstate,
              invcountryId,
              invisOtherPreName ? invotherName : invprename,
              invcontactPerson,
              invdesignation,
              invemailId,
              invprephone != null && invprephone != ""
                ? `${invprephone}-${invphone}`
                : invphone,
              GSTno,
              PANno,
              finalbusinessList,
              finalexportsList,
              finalproductsList,
              annualRevenue,
              documentsList,
              otherBusiness,
              otherPrimaryProduct,
              primaryProduct,
            )
            .then((data) => {
              if (data.error != 1) {
                if (data.data.ErrorMsg == null) {
                  this.setState({ isLoading: false }, () =>
                    toastSuccess("Updated Successfully")
                  );
                } else {
                  this.setState({ isLoading: false });
                  toastError(data.data.ErrorMsg);
                  this.props.navigate("/user_list");
                }
              } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
                if (
                  data.msg == sessionExpireMessage ||
                  data.msg == tokenInavlidMessage
                ) {
                  //after session expire.....................
                  sessionStorage.clear();
                  this.props.navigate("/");
                  setTimeout(() => {
                    toastError(data.msg);
                  }, 2000);
                } else {
                  toastError(data.data);
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.setState({
            regstateErr: "Please enter proper state",
          });
          toastError("Please enter mandatory fields");
        }
      } else {
        toastError("Please enter mandatory fields");
      }
    });
  }

  inputValidation() {
    const {
      invemailIdErr,
      companyName,
      emailIdErr,
      companywebsite,
      yearOfEstablishment,
      companyAdd1,
      companyAdd2,
      city,
      regstate,
      countryId,
      contactPerson,
      designation,
      emailId,
      phone,
      invcompanyName,
      invcompanywebsite,
      invyearOfEstablishment,
      invcompanyAdd1,
      invcompanyAdd2,
      invcity,
      invregstate,
      invcountryId,
      invcontactPerson,
      invdesignation,
      invemailId,
      invphone,
      GstNoErr,
      businessList,
      otherBusiness,
      PanNoErr,
    } = this.state;
    var Err = false;
    return new Promise((resolve) => {
      if (companyName == "" || companyName == null) {
        Err = true;
        this.setState({ companyNameErr: "Please enter Company Name" });
      }
      if (companywebsite == "" || companywebsite == null) {
        Err = true;
        this.setState({ companywebsiteErr: "Please enter Company Website" });
      }
      if (yearOfEstablishment == "" || yearOfEstablishment == null) {
        Err = true;
        this.setState({
          yearOfEstablishmentErr: "Please enter Year of Establishment",
        });
      }
      if (companyAdd1 == "" || companyAdd1 == null) {
        Err = true;
        this.setState({
          companyAdd1Err: "Please enter Company Headquarters Address 1",
        });
      }
      if (companyAdd2 == "" || companyAdd2 == null) {
        Err = true;
        this.setState({
          companyAdd2Err: "Please enter Company Headquarters Address 2",
        });
      }
      if (city == "" || city == null) {
        Err = true;
        this.setState({ cityErr: "Please enter City" });
      }
      if (regstate == "" || regstate == null) {
        Err = true;
        this.setState({ regstateErr: "Please enter State" });
      }
      if (countryId == "" || countryId == null) {
        Err = true;
        this.setState({ countryIdErr: "Please select Country" });
      }
      if (contactPerson == "" || contactPerson == null) {
        Err = true;
        this.setState({ contactPersonErr: "Please enter Contact Person" });
      }
      if (designation == "" || designation == null) {
        Err = true;
        this.setState({ designationErr: "Please enter Designation" });
      }
      if (emailId == "" || emailId == null) {
        Err = true;
        this.setState({ emailIdErr: "Please enter Email" });
      } else {
        var ErrMsg = emailValidator(emailId);
        if (ErrMsg != "") {
          Err = true;
          this.setState({ emailIdErr: ErrMsg });
        }
      }
      if (emailIdErr != "" && emailIdErr != null) {
        Err = true;
      }
      if (phone == "" || phone == null) {
        Err = true;
        this.setState({ phoneErr: "Please enter Phone No." });
      }
      // INVVVVV
      if (invcompanyName == "" || invcompanyName == null) {
        Err = true;
        this.setState({
          invcompanyNameErr: "Please enter Invoice Company Name",
        });
      }
      if (invcompanywebsite == "" || invcompanywebsite == null) {
        Err = true;
        this.setState({
          invcompanywebsiteErr: "Please enter invoice Company Website",
        });
      }
      if (invyearOfEstablishment == "" || invyearOfEstablishment == null) {
        Err = true;
        this.setState({
          invyearOfEstablishmentErr:
            "Please enter invoice Year of Establishment",
        });
      }
      if (invcompanyAdd1 == "" || invcompanyAdd1 == null) {
        Err = true;
        this.setState({
          invcompanyAdd1Err:
            "Please enter invoice Company Headquarters Address 1",
        });
      }
      if (invcompanyAdd2 == "" || invcompanyAdd2 == null) {
        Err = true;
        this.setState({
          invcompanyAdd2Err:
            "Please enter invoice Company Headquarters Address 2",
        });
      }
      if (invcity == "" || invcity == null) {
        Err = true;
        this.setState({ invcityErr: "Please enter invoice City" });
      }
      if (invregstate == "" || invregstate == null) {
        Err = true;
        this.setState({ invregstateErr: "Please enter invoice State" });
      }
      if (invcountryId == "" || invcountryId == null) {
        Err = true;
        this.setState({ invcountryIdErr: "Please select invoice Country" });
      }
      if (invcontactPerson == "" || invcontactPerson == null) {
        Err = true;
        this.setState({
          invcontactPersonErr: "Please enter invoice Contact Person",
        });
      }
      if (invdesignation == "" || invdesignation == null) {
        Err = true;
        this.setState({
          invdesignationErr: "Please enter invoice Designation",
        });
      }
      if (invemailId == "" || invemailId == null) {
        Err = true;
        this.setState({ invemailIdErr: "Please enter  invoice Email" });
      } else {
        var ErrMsg = emailValidator(invemailId);
        if (ErrMsg != "") {
          Err = true;
          this.setState({ invemailIdErr: ErrMsg });
        }
      }
      if (invemailIdErr != "" && invemailIdErr != null) {
        Err = true;
      }
      if (invphone == "" || invphone == null) {
        Err = true;
        this.setState({ invphoneErr: "Please enter invoice Phone No." });
      }
      console.log(
        "doc val 1",
        JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID
      );
      if (JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID === 91) {
        console.log("doc val 2");
        for (let i = 0; i < this.state.documentsList.length; i++) {
          const { no, file, docId } = this.state.documentsList[i];
          console.log("doc val 3", no, file, docId);
          if (docId === 1) {
            // GST Validation
            if (!no || no.trim() === "") {
              this.setState({ GstNoErr: "Please enter GST number" });
              Err = true;
            } else if (
              !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/.test(
                no
              )
            ) {
              this.setState({ GstNoErr: "Invalid GST number format" });
              Err = true;
            }
            if (!file) {
              this.setState({ GstdocErr: "Please upload GST document" });
              Err = true;
            }
          }

          if (docId === 2) {
            // PAN Validation
            if (!no || no.trim() === "") {
              this.setState({ PanNoErr: "Please enter PAN number" });
              Err = true;
            } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(no)) {
              this.setState({ PanNoErr: "Invalid PAN number format" });
              Err = true;
            }
            if (!file) {
              this.setState({ PandocErr: "Please upload PAN document" });
              Err = true;
            }
          }
        }
      }

      // for (var i = 0; i < this.state.productsList.length; i++) {
      //     if (this.state.productsList[i].isSelect) {
      //         ppNoErr = true
      //     }
      // }
      if (
        this.state.primaryProduct == "" ||
        this.state.primaryProduct == null
      ) {
        this.setState({
          primaryProductsErr: "Please enter Primary product/service",
        });
        Err = true;
      }
      var buissnessNoErr = false;
      for (var i = 0; i < this.state.businessList.length; i++) {
        if (this.state.businessList[i].isSelect) {
          buissnessNoErr = true;
        }
      }
      // if (!ppNoErr) {
      //     this.setState({ primaryProductsErr: 'Please select atleast one Primary Products/Services' })
      //     Err = true
      // }
      if (!buissnessNoErr) {
        this.setState({
          businessListErr: "Please select atleast one Buisness",
        });
        Err = true;
      }
      if (GstNoErr != "" && GstNoErr != null) {
        Err = true;
      }
      for (var i = 1; i < businessList.length; i++) {
        if (
          businessList[i].Description == "Others" &&
          businessList[i].isSelect
        ) {
          if (otherBusiness.trim() == "") {
            Err = true;
            this.setState({ otherBusinessErr: "Enter Other Buisness" });
          }
        }
      }
      resolve(Err);
    });
  }
  sameAsCorrespondenceClick() {
    const {
      companywebsite,
      industryId,
      yearOfEstablishment,
      companyAdd1,
      companyAdd2,
      contactPerson,
      designation,
      emailId,
      phone,
      sameAsCorrespondence,
      prename,
      isOtherPreName,
      otherName,
      prephone,
    } = this.state;
    this.setState({ sameAsCorrespondence: !sameAsCorrespondence }, () => {
      if (sameAsCorrespondence == false) {
        this.setState({
          invcompanywebsite: companywebsite,
          invindustryId: industryId,
          invyearOfEstablishment: yearOfEstablishment,
          invcompanyAdd1: companyAdd1,
          invcompanyAdd2: companyAdd2,
          invcontactPerson: contactPerson,
          invdesignation: designation,
          invemailId: emailId,
          invphone: phone,
          invisOtherPreName: isOtherPreName,
          invotherName: otherName,
          invprename: prename,
          invprephone: prephone,
          // invcompanyNameErr: '',
          invcompanywebsiteErr: "",
          invindustryIdErr: "",
          invyearOfEstablishmentErr: "",
          invcompanyAdd1Err: "",
          invcompanyAdd2Err: "",
          // invcityErr: '',
          // invregstateErr: '',
          // invcountryIdErr: '',
          invcontactPersonErr: "",
          invdesignationErr: "",
          invemailIdErr: "",
          invphoneErr: "",
        });
      }
      if (sameAsCorrespondence == true) {
        this.setState({
          // invcompanyName: '',
          invcompanywebsite: "",
          invindustryId: "",
          invyearOfEstablishment: "",
          invcompanyAdd1: "",
          invcompanyAdd2: "",
          // invcity: '',
          // invregstate: '',
          // invcountryId: '',
          invcontactPerson: "",
          invdesignation: "",
          invemailId: "",
          invphone: "",
          invisOtherPreName: false,
          invotherName: "",
          invprename: "Mr",
          invprephone: "",
          // invcompanyNameErr: '',
          invcompanywebsiteErr: "",
          invindustryIdErr: "",
          invyearOfEstablishmentErr: "",
          invcompanyAdd1Err: "",
          invcompanyAdd2Err: "",
          // invcityErr: '',
          // invregstateErr: '',
          // invcountryIdErr: '',
          invcontactPersonErr: "",
          invdesignationErr: "",
          invemailIdErr: "",
          invphoneErr: "",
        });
      }
    });
  }
  handleKeyDown = (e, mode, status) => {
    const {
      focusedIndexState,
      tempStateList,
      tempCityList,
      focusedIndexCity,
      invfocusedIndexCity,
      invfocusedIndexState,
    } = this.state;
    if (mode == 0) {
      if (status == 0) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          // Move focus down
          this.setState(
            {
              focusedIndexState: Math.min(
                focusedIndexState + 1,
                tempStateList.length - 1
              ),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          // Move focus up
          this.setState(
            {
              focusedIndexState: Math.max(focusedIndexState - 1, 0),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "Enter" && focusedIndexState >= 0) {
          // Select the focused item when Enter is pressed
          this.handleSelect(tempStateList[focusedIndexState], mode, status);
        }
      } else if (status == 1) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          // Move focus down
          this.setState(
            {
              invfocusedIndexState: Math.min(
                invfocusedIndexState + 1,
                tempStateList.length - 1
              ),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          // Move focus up
          this.setState(
            {
              invfocusedIndexState: Math.max(invfocusedIndexState - 1, 0),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "Enter" && invfocusedIndexState >= 0) {
          // Select the focused item when Enter is pressed
          this.handleSelect(tempStateList[invfocusedIndexState], mode, status);
        }
      }
    } else if (mode == 1) {
      if (status == 0) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          // Move focus down
          this.setState(
            {
              focusedIndexCity: Math.min(
                focusedIndexCity + 1,
                tempCityList.length - 1
              ),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          // Move focus up
          this.setState(
            {
              focusedIndexCity: Math.max(focusedIndexCity - 1, 0),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "Enter" && focusedIndexCity >= 0) {
          // Select the focused item when Enter is pressed
          this.handleSelect(tempCityList[focusedIndexCity], mode, status);
        }
      } else if (status == 1) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          // Move focus down
          this.setState(
            {
              invfocusedIndexCity: Math.min(
                invfocusedIndexCity + 1,
                tempCityList.length - 1
              ),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          // Move focus up
          this.setState(
            {
              invfocusedIndexCity: Math.max(invfocusedIndexCity - 1, 0),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "Enter" && invfocusedIndexCity >= 0) {
          // Select the focused item when Enter is pressed
          this.handleSelect(tempCityList[invfocusedIndexCity], mode, status);
        }
      }
    }
  };

  handleHover = (index, mode, status) => {
    if (mode == 0) {
      if (status == 0) {
        this.setState({ focusedIndexState: index });
      } else if (status == 1) {
        this.setState({ invfocusedIndexState: index });
      }
    } else if (mode == 1) {
      if (status == 0) {
        this.setState({ focusedIndexCity: index });
      } else if (status == 1) {
        this.setState({ invfocusedIndexCity: index });
      }
    }
  };

  scrollIntoView = (mode, status) => {
    // console.log(mode, status)
    const {
      focusedIndexState,
      invfocusedIndexCity,
      invfocusedIndexState,
      focusedIndexCity,
    } = this.state;
    if (mode == 0) {
      if (status == 0) {
        const dropdownMenu = document.querySelector(".dropdown-menu"); // Get the dropdown menu
        if (!dropdownMenu) return;

        const focusedItem = dropdownMenu.children[focusedIndexState];
        if (!focusedItem) return;

        // Scroll the dropdown menu if the focused item is not fully visible
        const dropdownTop = dropdownMenu.getBoundingClientRect().top;
        const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
        const itemTop = focusedItem.getBoundingClientRect().top;
        const itemBottom = focusedItem.getBoundingClientRect().bottom;
        const menuTop = dropdownMenu.scrollTop;
        const menuHeight = dropdownMenu.offsetHeight;
        console.log("+++++++++++++++++++++++++++++x");
        console.log(dropdownTop);
        console.log(dropdownBottom);
        console.log(itemTop);
        console.log(itemBottom);
        console.log(menuTop);
        console.log(menuHeight);

        // Check if the focused item is outside the visible area and adjust the scroll
        if (itemBottom > dropdownBottom) {
          dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
        } else if (itemTop < dropdownTop) {
          dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
        }
      } else if (status == 1) {
        const dropdownMenu = document.querySelector(".dropdown-menu"); // Get the dropdown menu
        if (!dropdownMenu) return;

        const focusedItem = dropdownMenu.children[invfocusedIndexState];
        if (!focusedItem) return;

        // Scroll the dropdown menu if the focused item is not fully visible
        const dropdownTop = dropdownMenu.getBoundingClientRect().top;
        const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
        const itemTop = focusedItem.getBoundingClientRect().top;
        const itemBottom = focusedItem.getBoundingClientRect().bottom;
        const menuTop = dropdownMenu.scrollTop;
        const menuHeight = dropdownMenu.offsetHeight;
        console.log("+++++++++++++++++++++++++++++x");
        console.log(dropdownTop);
        console.log(dropdownBottom);
        console.log(itemTop);
        console.log(itemBottom);
        console.log(menuTop);
        console.log(menuHeight);

        // Check if the focused item is outside the visible area and adjust the scroll
        if (itemBottom > dropdownBottom) {
          dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
        } else if (itemTop < dropdownTop) {
          dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
        }
      }
    } else if (mode == 1) {
      if (status == 0) {
        const dropdownMenu = document.querySelector(".dropdown-menu"); // Get the dropdown menu
        if (!dropdownMenu) return;

        const focusedItem = dropdownMenu.children[focusedIndexCity];
        if (!focusedItem) return;

        // Scroll the dropdown menu if the focused item is not fully visible
        const dropdownTop = dropdownMenu.getBoundingClientRect().top;
        const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
        const itemTop = focusedItem.getBoundingClientRect().top;
        const itemBottom = focusedItem.getBoundingClientRect().bottom;
        const menuTop = dropdownMenu.scrollTop;
        const menuHeight = dropdownMenu.offsetHeight;
        console.log("+++++++++++++++++++++++++++++x");
        console.log(dropdownTop);
        console.log(dropdownBottom);
        console.log(itemTop);
        console.log(itemBottom);
        console.log(menuTop);
        console.log(menuHeight);

        // Check if the focused item is outside the visible area and adjust the scroll
        if (itemBottom > dropdownBottom) {
          dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
        } else if (itemTop < dropdownTop) {
          dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
        }
      } else if (status == 1) {
        const dropdownMenu = document.querySelector(".dropdown-menu"); // Get the dropdown menu
        if (!dropdownMenu) return;

        const focusedItem = dropdownMenu.children[invfocusedIndexCity];
        if (!focusedItem) return;

        // Scroll the dropdown menu if the focused item is not fully visible
        const dropdownTop = dropdownMenu.getBoundingClientRect().top;
        const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
        const itemTop = focusedItem.getBoundingClientRect().top;
        const itemBottom = focusedItem.getBoundingClientRect().bottom;
        const menuTop = dropdownMenu.scrollTop;
        const menuHeight = dropdownMenu.offsetHeight;
        console.log("+++++++++++++++++++++++++++++x");
        console.log(dropdownTop);
        console.log(dropdownBottom);
        console.log(itemTop);
        console.log(itemBottom);
        console.log(menuTop);
        console.log(menuHeight);

        // Check if the focused item is outside the visible area and adjust the scroll
        if (itemBottom > dropdownBottom) {
          dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
        } else if (itemTop < dropdownTop) {
          dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
        }
      }
    }
  };

  onCountrySelect(e, status) {
    const { countryList } = this.state;
    var countryId = e.target.value;
    if (status == 1) {
      this.setState({ countryId: countryId, countryIdErr: "" });
      var countryCode =
        countryId != ""
          ? countryList.filter((obj) => obj.Code == countryId)[0].CountryCode
          : "";
      this.setState({
        prephone: `+${countryCode}`,
      });
    } else {
      this.setState({ invcountryId: countryId, invcountryIdErr: "" });
      var countryCode =
        countryId != ""
          ? countryList.filter((obj) => obj.Code == countryId)[0].CountryCode
          : "";
      this.setState({
        invprephone: `+${countryCode}`,
      });
    }
    this.setState({
      regstateErr: "",
      cityErr: "",
    });
    this.getFillList(stateActionId, "", countryId, "", "");
    this.getFillList(cityActionId, "", countryId, "", "");
  }

  onIndustrySelect(e, status) {
    // const {  } = this.state
    var industry = e.target.value;
    if (status == 1) {
      this.setState({ industryId: industry, industryIdErr: "" });
    } else {
      this.setState({ invindustryId: industry, invindustryIdErr: "" });
    }
  }

  onEmailInput(value, mode) {
    var ErrMsg = emailValidator(value);
    if (mode == 1) {
      this.setState({
        invemailIdErr: ErrMsg,
      });
    } else {
      this.setState({
        emailIdErr: ErrMsg,
      });
    }
  }

  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  preventMinus = (e) => {
    (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault();
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };

  handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData("text/plain");
    const sanitizedValue = pastedValue.replace(/[-.eE]/g, ""); // Remove '-', '.', 'e', 'E' characters

    // Replace the input value with the sanitized value
    document.execCommand("insertText", false, sanitizedValue);

    event.preventDefault(); // Prevent the default paste behavior
  };
  navigateBackUserList() {
    if (sessionStorage.getItem("RoleIDSS") == 5) {
      this.props.navigate("/memberDashboard");
    } else {
      this.props.navigate("/user_list");
    }
  }
  render() {
    const {
      isLoading,
      countryList,
      companyName,
      companywebsite,
      yearOfEstablishment,
      companyAdd1,
      companyAdd2,
      city,
      regstate,
      countryId,
      contactPerson,
      designation,
      emailId,
      phone,
      sameAsCorrespondence,
      invcompanyName,
      invcompanywebsite,
      invyearOfEstablishment,
      invcompanyAdd1,
      invcompanyAdd2,
      invcity,
      invregstate,
      invcountryId,
      invcontactPerson,
      invdesignation,
      invemailId,
      invphone,
      prename,
      isOtherPreName,
      otherName,
      isOpenDropDownState,
      prephone,
      invprephone,
      isOpenDropDownCity,
      tempStateList,
      tempCityList,
      companyNameErr,
      companywebsiteErr,
      yearOfEstablishmentErr,
      companyAdd1Err,
      companyAdd2Err,
      cityErr,
      regstateErr,
      countryIdErr,
      contactPersonErr,
      designationErr,
      emailIdErr,
      phoneErr,
      invcompanyNameErr,
      invcompanywebsiteErr,
      invyearOfEstablishmentErr,
      invcompanyAdd1Err,
      invcompanyAdd2Err,
      invcityErr,
      invregstateErr,
      invcountryIdErr,
      invcontactPersonErr,
      invdesignationErr,
      invemailIdErr,
      invphoneErr,
      invisOpenDropDownState,
      invisOpenDropDownCity,
      viewMode,
      primaryProduct,
      primaryProductsErr,
      businessList,
      exportsList,
      docTypeList,
      annualRevenue,
      documentsList,
      isOpen,
    } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        {/* <ToastContainer />. */}
        <Header />
        <ToastContainer />
        <section class="registration_form">
          <div class="container">
            <h6 className="pt-2">User Details</h6>
            <div class="row mt-15">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <div class="custom_tabs" id="mytabs">
                      <div class="tab-content">
                        <div
                          class="tab-pane active"
                          id="Company_Profile_tab"
                          role="tabpanel"
                          aria-labelledby="Company_Profile_tab"
                          tabindex="0"
                        >
                          <fieldset>
                            <legend className="mb-0 pb-0">
                              Company Profile
                            </legend>

                            <div class="row">
                              <div class="col-md-12">
                                <div class="row mb-3">
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Company Name
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter Company name"
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        value={companyName}
                                        onChange={(e) =>
                                          this.setState({
                                            companyName: e.target.value,
                                            companyNameErr: "",
                                          })
                                        }
                                        maxLength={1000}
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block  ml-2">
                                          {companyNameErr}
                                        </span>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Company Website
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter Company Website name"
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        value={companywebsite}
                                        onChange={(e) =>
                                          this.setState({
                                            companywebsite: e.target.value,
                                            companywebsiteErr: "",
                                          })
                                        }
                                        maxLength={200}
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block  ml-2">
                                          {companywebsiteErr}
                                        </span>
                                      }
                                    </div>
                                  </div>
                                  {/* <div class="col-md-3">
                                                                        <div class="form-group">
                                                                            <label>Industry<span className="red-star text-danger">*</span></label>
                                                                            <select className="form-control" value={industryId}
                                                                                onChange={(e) => this.onIndustrySelect(e, 1)}
                                                                            >
                                                                                <option value={''}>Select Industry</option>
                                                                                {
                                                                                    industryList.length > 0 && industryList.map((data) => (
                                                                                        <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                        {<span className='text-danger text-start text-left d-block  ml-2'>{industryIdErr}</span>}
                                                                    </div> */}
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Year of Establishment
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="number"
                                        class="form-control"
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        placeholder="Year of Establishment"
                                        value={yearOfEstablishment}
                                        onChange={(e) =>
                                          this.setState({
                                            yearOfEstablishment: e.target.value,
                                            yearOfEstablishmentErr: "",
                                          })
                                        }
                                        maxLength={20}
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {yearOfEstablishmentErr}
                                      </span>
                                    }
                                  </div>

                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Company Headquarters Address 1
                                        <span className="red-star text-danger">
                                          *
                                        </span>{" "}
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        placeholder="Address line 1"
                                        value={companyAdd1}
                                        onChange={(e) =>
                                          this.setState({
                                            companyAdd1: e.target.value,
                                            companyAdd1Err: "",
                                          })
                                        }
                                        maxLength={400}
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {companyAdd1Err}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Company Headquarters Address 2
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        placeholder="Address line 2"
                                        value={companyAdd2}
                                        onChange={(e) =>
                                          this.setState({
                                            companyAdd2: e.target.value,
                                            companyAdd2Err: "",
                                          })
                                        }
                                        maxLength={400}
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {companyAdd2Err}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Country
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <select
                                        className="form-control"
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        value={countryId}
                                        onChange={(e) =>
                                          this.onCountrySelect(e, 1)
                                        }
                                      >
                                        <option value={""}>
                                          Select Your Country
                                        </option>
                                        {countryList.length > 0 &&
                                          countryList.map((data) => (
                                            <option
                                              key={data.Code}
                                              value={data.Code}
                                            >
                                              {data.Description}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {countryIdErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        City
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <Form.Control
                                        type="text"
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        // placeholder="Search..."
                                        value={city}
                                        onChange={(e) =>
                                          !/^[a-zA-Z\s]+$/.test(
                                            e.target.value
                                          ) && e.target.value != ""
                                            ? null
                                            : this.handleSearchChange(e, 1, 0)
                                        }
                                        // onChange={this.handleSearchChange}
                                        onFocus={() =>
                                          city.length > 0 &&
                                          this.setState({
                                            isOpenDropDownCity: true,
                                          })
                                        }
                                        // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                        onBlur={() =>
                                          setTimeout(() => {
                                            this.setState({
                                              isOpenDropDownCity: false,
                                            });
                                          }, 500)
                                        }
                                        onKeyDown={(e) =>
                                          this.handleKeyDown(e, 1, 0)
                                        }
                                        autoFocus
                                        placeholder="Enter City"
                                        maxLength={100}
                                      />

                                      {/* Dropdown options - shown only if there are results */}
                                      {isOpenDropDownCity &&
                                        tempCityList.length > 0 && (
                                          <Dropdown.Menu
                                            show
                                            style={{
                                              position: "absolute",
                                              width: "100%",
                                              zIndex: 1,
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                              padding: 0,
                                            }}
                                          >
                                            {tempCityList.map((item, index) => (
                                              <Dropdown.Item
                                                key={index}
                                                onClick={() =>
                                                  this.handleSelect(item, 1, 0)
                                                }
                                                // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                style={{
                                                  whiteSpace: "normal",
                                                  height: "40px",
                                                  wordWrap: "break-word",
                                                  overflowWrap: "break-word",
                                                  cursor: "pointer",
                                                  transition: "none",
                                                  backgroundColor:
                                                    this.state
                                                      .focusedIndexCity ===
                                                    index
                                                      ? "#744587"
                                                      : "transparent",
                                                  color:
                                                    this.state
                                                      .focusedIndexCity ===
                                                    index
                                                      ? "white"
                                                      : "black",
                                                }}
                                                onMouseEnter={() =>
                                                  this.handleHover(index, 1, 0)
                                                }
                                              >
                                                {item.Description}
                                              </Dropdown.Item>
                                            ))}
                                          </Dropdown.Menu>
                                        )}
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {cityErr}
                                      </span>
                                    }
                                  </div>

                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        State
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <Form.Control
                                        type="text"
                                        // placeholder="Search..."
                                        value={regstate}
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        onChange={(e) =>
                                          !/^[a-zA-Z\s]+$/.test(
                                            e.target.value
                                          ) && e.target.value != ""
                                            ? null
                                            : this.handleSearchChange(e, 0, 0)
                                        }
                                        // onChange={this.handleSearchChange}
                                        onFocus={() =>
                                          regstate.length > 0 &&
                                          this.setState({
                                            isOpenDropDownState: true,
                                          })
                                        }
                                        // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                        onBlur={() =>
                                          setTimeout(() => {
                                            this.setState({
                                              isOpenDropDownState: false,
                                            });
                                          }, 500)
                                        }
                                        onKeyDown={(e) =>
                                          this.handleKeyDown(e, 0, 0)
                                        }
                                        autoFocus
                                        placeholder="Enter State"
                                        maxLength={100}
                                      />

                                      {/* Dropdown options - shown only if there are results */}
                                      {isOpenDropDownState &&
                                        tempStateList.length > 0 && (
                                          <Dropdown.Menu
                                            show
                                            style={{
                                              position: "absolute",
                                              width: "100%",
                                              zIndex: 1,
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                              padding: 0,
                                            }}
                                          >
                                            {tempStateList.map(
                                              (item, index) => (
                                                <Dropdown.Item
                                                  key={index}
                                                  onClick={() =>
                                                    this.handleSelect(
                                                      item,
                                                      0,
                                                      0
                                                    )
                                                  }
                                                  // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                  style={{
                                                    whiteSpace: "normal",
                                                    height: "40px",
                                                    wordWrap: "break-word",
                                                    overflowWrap: "break-word",
                                                    cursor: "pointer",
                                                    transition: "none",
                                                    backgroundColor:
                                                      this.state
                                                        .focusedIndexState ===
                                                      index
                                                        ? "#744587"
                                                        : "transparent",
                                                    color:
                                                      this.state
                                                        .focusedIndexState ===
                                                      index
                                                        ? "white"
                                                        : "black",
                                                  }}
                                                  onMouseEnter={() =>
                                                    this.handleHover(
                                                      index,
                                                      0,
                                                      0
                                                    )
                                                  }
                                                >
                                                  {item.Description}
                                                </Dropdown.Item>
                                              )
                                            )}
                                          </Dropdown.Menu>
                                        )}
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {regstateErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Key Contact Person
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      {isOtherPreName && (
                                        <input
                                          type="text"
                                          className="form-control-1"
                                          // maxLength={}
                                          disabled={
                                            sessionStorage.getItem(
                                              "RoleIDSS"
                                            ) == 5
                                              ? true
                                              : viewMode
                                          }
                                          value={otherName}
                                          onChange={(e) =>
                                            this.setState({
                                              otherName: e.target.value,
                                            })
                                          }
                                          placeholder={"Other"}
                                          style={{
                                            position: "absolute",
                                            display: !isOtherPreName && "none",
                                            paddingLeft: "5px",
                                            width: "45px",
                                            top: "60px",
                                            // color:'grey'
                                          }}
                                          maxLength={20}
                                        />
                                      )}
                                      <div className="col-md-1">
                                        <div
                                          className="form-group"
                                          style={{
                                            width: 45,
                                            position: "absolute",
                                            left: 0,
                                            zIndex: 1,
                                            top: "28px",
                                            fontSize: "12px",
                                            // color:'grey'
                                          }}
                                        >
                                          <label />
                                          <select
                                            className="form-control-1 select2 select-hidden-accessible"
                                            id="validationCustom03"
                                            required=""
                                            disabled={
                                              sessionStorage.getItem(
                                                "RoleIDSS"
                                              ) == 5
                                                ? true
                                                : viewMode
                                            }
                                            style={{
                                              borderTop: "none",
                                              borderBottom: "none",
                                              marginTop: 2,
                                              borderRadius: 0,
                                              borderLeft: 0,
                                              height: 33,
                                              padding: 0,
                                              color: "grey",
                                              background: "none",
                                            }}
                                            value={prename}
                                            onChange={(e) =>
                                              this.setState({
                                                prename: e.target.value,
                                                isOtherPreName:
                                                  e.target.value == "Other" &&
                                                  true,
                                              })
                                            }
                                          >
                                            <option value="Mr">Mr</option>
                                            <option value="Ms">Ms</option>
                                            <option value="DR">DR</option>
                                            <option value="Prof">Prof</option>
                                            <option value="Other">Other</option>
                                          </select>
                                        </div>
                                      </div>
                                      <input
                                        type="text"
                                        style={{
                                          position: "relative",
                                          paddingLeft: 55,
                                        }}
                                        class="form-control"
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        placeholder="Contact Person"
                                        value={contactPerson}
                                        onChange={(e) =>
                                          this.setState({
                                            contactPerson: e.target.value,
                                            contactPersonErr: "",
                                          })
                                        }
                                        maxLength={200}
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {contactPersonErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Position/Title/Designation
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        class="form-control"
                                        placeholder="Enter Contact person designation"
                                        value={designation}
                                        onChange={(e) =>
                                          this.setState({
                                            designation: e.target.value,
                                            designationErr: "",
                                          })
                                        }
                                        maxLength={100}
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {designationErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Email Id
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="email"
                                        class="form-control"
                                        placeholder="Enter Email"
                                        value={emailId}
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        onChange={(e) =>
                                          this.setState({
                                            emailId: e.target.value,
                                            emailIdErr: "",
                                          })
                                        }
                                        onBlur={(e) =>
                                          this.onEmailInput(e.target.value, 0)
                                        }
                                        maxLength={100}
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {emailIdErr}
                                      </span>
                                    }
                                  </div>

                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Phone Number
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control-1"
                                        value={prephone}
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        placeholder="ISD"
                                        maxLength={"11"}
                                        onChange={(e) =>
                                          this.setState({
                                            prephone: e.target.value,
                                          })
                                        }
                                        style={{
                                          width: 55,
                                          position: "absolute",
                                          // top: 30,
                                          textAlign: "center",
                                          padding: " 6px !important",
                                          paddingLeft: prephone == "" ? 10 : 0,
                                          borderLeft: 0,
                                          borderTop: 0,
                                          background: "none",
                                          borderBottom: 0,
                                          height: 34,
                                          zIndex: isOpenDropDownState ? 0 : 10,
                                          color: "grey",
                                        }}
                                      />
                                      <input
                                        type="number"
                                        class="form-control"
                                        placeholder="Enter Phone no"
                                        style={{
                                          position: "relative",
                                          paddingLeft: 65,
                                        }}
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        maxLength={
                                          countryId == 91 ? "10" : "11"
                                        }
                                        onInput={(e) =>
                                          this.maxLengthCheck(e, 10)
                                        }
                                        onKeyDown={(e) => this.preventMinus(e)}
                                        onPaste={(e) => this.handlePaste(e)}
                                        onWheel={(e) => e.target.blur()}
                                        value={phone}
                                        onChange={(e) =>
                                          this.setState({
                                            phone: e.target.value,
                                            phoneErr: "",
                                          })
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {phoneErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </fieldset>

                          <fieldset>
                            <legend className="mb-0 pb-0">
                              Invoice Details
                            </legend>

                            <div class="row mb-3">
                              <div class="col-md-12">
                                <div class="form-group float-right">
                                  <div
                                    class="custom-control custom-checkbox"
                                    onClick={() => {
                                      if (
                                        !(sessionStorage.getItem("RoleIDSS") ==
                                        5
                                          ? true
                                          : viewMode)
                                      ) {
                                        this.sameAsCorrespondenceClick();
                                      }
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      class="custom-control-input"
                                      disabled={viewMode}
                                      checked={sameAsCorrespondence}
                                      value={sameAsCorrespondence}
                                    />
                                    <label
                                      class="custom-control-label"
                                      for="Correspondence_Details"
                                    >
                                      Same as Correspondence Details
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-12">
                                <div class="row mb-3">
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Company Name
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        maxLength={1000}
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter Company name"
                                        value={invcompanyName}
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        onChange={(e) =>
                                          this.setState({
                                            invcompanyName: e.target.value,
                                            invcompanyNameErr: "",
                                          })
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invcompanyNameErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Company Website
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        maxLength={200}
                                        disabled={
                                          sameAsCorrespondence || viewMode
                                        }
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter Company Website name"
                                        value={invcompanywebsite}
                                        onChange={(e) =>
                                          this.setState({
                                            invcompanywebsite: e.target.value,
                                            invcompanywebsiteErr: "",
                                          })
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invcompanywebsiteErr}
                                      </span>
                                    }
                                  </div>
                                  {/* <div class="col-md-3">
                                                                        <div class="form-group">
                                                                            <label>Industry<span className="red-star text-danger">*</span></label>
                                                                            <select disabled={sameAsCorrespondence||viewMode} className="form-control" value={invindustryId}
                                                                                onChange={(e) => this.onIndustrySelect(e, 2)}
                                                                            >
                                                                                <option value={''}>Select Industry</option>
                                                                                {
                                                                                    industryList.length > 0 && industryList.map((data) => (
                                                                                        <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                        {<span className='text-danger text-start text-left d-block  ml-2'>{invindustryIdErr}</span>}
                                                                    </div> */}
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Year of Establishment
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        maxLength={20}
                                        disabled={
                                          sameAsCorrespondence || viewMode
                                        }
                                        type="number"
                                        class="form-control"
                                        placeholder="Year of Establishment"
                                        value={invyearOfEstablishment}
                                        onChange={(e) =>
                                          this.setState({
                                            invyearOfEstablishment:
                                              e.target.value,
                                            invyearOfEstablishmentErr: "",
                                          })
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invyearOfEstablishmentErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Company Headquarters Address 1
                                        <span className="red-star text-danger">
                                          *
                                        </span>{" "}
                                      </label>
                                      <input
                                        maxLength={400}
                                        disabled={
                                          sameAsCorrespondence || viewMode
                                        }
                                        type="text"
                                        class="form-control"
                                        placeholder="Address line 1"
                                        value={invcompanyAdd1}
                                        onChange={(e) =>
                                          this.setState({
                                            invcompanyAdd1: e.target.value,
                                            invcompanyAdd1Err: "",
                                          })
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invcompanyAdd1Err}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Company Headquarters Address 2
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        maxLength={400}
                                        disabled={
                                          sameAsCorrespondence || viewMode
                                        }
                                        type="text"
                                        class="form-control"
                                        placeholder="Address line 2"
                                        value={invcompanyAdd2}
                                        onChange={(e) =>
                                          this.setState({
                                            invcompanyAdd2: e.target.value,
                                            invcompanyAdd2Err: "",
                                          })
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invcompanyAdd2Err}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Country
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <select
                                        disabled={
                                          sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode
                                        }
                                        className="form-control"
                                        value={invcountryId}
                                        onChange={(e) =>
                                          this.onCountrySelect(e, 2)
                                        }
                                      >
                                        <option value={""}>
                                          Select Your Country
                                        </option>
                                        {countryList.length > 0 &&
                                          countryList.map((data) => (
                                            <option
                                              key={data.Code}
                                              value={data.Code}
                                            >
                                              {data.Description}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invcountryIdErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        City
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <Form.Control
                                        disabled={
                                          sameAsCorrespondence ||
                                          (sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode)
                                        }
                                        type="text"
                                        // placeholder="Search..."
                                        value={invcity}
                                        onChange={(e) =>
                                          !/^[a-zA-Z\s]+$/.test(
                                            e.target.value
                                          ) && e.target.value != ""
                                            ? null
                                            : this.handleSearchChange(e, 1, 1)
                                        }
                                        // onChange={this.handleSearchChange}
                                        onFocus={() =>
                                          invcity.length > 0 &&
                                          this.setState({
                                            invisOpenDropDownCity: true,
                                          })
                                        }
                                        // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                        onBlur={() =>
                                          setTimeout(() => {
                                            this.setState({
                                              invisOpenDropDownCity: false,
                                            });
                                          }, 500)
                                        }
                                        onKeyDown={(e) =>
                                          this.handleKeyDown(e, 1, 1)
                                        }
                                        autoFocus
                                        placeholder="Enter City"
                                        maxLength={100}
                                      />

                                      {/* Dropdown options - shown only if there are results */}
                                      {invisOpenDropDownCity &&
                                        tempCityList.length > 0 && (
                                          <Dropdown.Menu
                                            show
                                            style={{
                                              position: "absolute",
                                              width: "100%",
                                              zIndex: 1,
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                              padding: 0,
                                            }}
                                          >
                                            {tempCityList.map((item, index) => (
                                              <Dropdown.Item
                                                key={index}
                                                onClick={() =>
                                                  this.handleSelect(item, 1, 1)
                                                }
                                                // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                style={{
                                                  whiteSpace: "normal",
                                                  height: "40px",
                                                  wordWrap: "break-word",
                                                  overflowWrap: "break-word",
                                                  cursor: "pointer",
                                                  transition: "none",
                                                  backgroundColor:
                                                    this.state
                                                      .invfocusedIndexCity ===
                                                    index
                                                      ? "#744587"
                                                      : "transparent",
                                                  color:
                                                    this.state
                                                      .invfocusedIndexCity ===
                                                    index
                                                      ? "white"
                                                      : "black",
                                                }}
                                                onMouseEnter={() =>
                                                  this.handleHover(index, 1, 1)
                                                }
                                              >
                                                {item.Description}
                                              </Dropdown.Item>
                                            ))}
                                          </Dropdown.Menu>
                                        )}
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invcityErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        State
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <Form.Control
                                        disabled={
                                          sameAsCorrespondence ||
                                          (sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode)
                                        }
                                        type="text"
                                        // placeholder="Search..."
                                        value={invregstate}
                                        onChange={(e) =>
                                          !/^[a-zA-Z\s]+$/.test(
                                            e.target.value
                                          ) && e.target.value != ""
                                            ? null
                                            : this.handleSearchChange(e, 0, 1)
                                        }
                                        // onChange={this.handleSearchChange}
                                        onFocus={() =>
                                          invregstate.length > 0 &&
                                          this.setState({
                                            invisOpenDropDownState: true,
                                          })
                                        }
                                        // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                        onBlur={() =>
                                          setTimeout(() => {
                                            this.setState({
                                              invisOpenDropDownState: false,
                                            });
                                          }, 500)
                                        }
                                        onKeyDown={(e) =>
                                          this.handleKeyDown(e, 0, 1)
                                        }
                                        autoFocus
                                        placeholder="Enter State"
                                        maxLength={100}
                                      />

                                      {/* Dropdown options - shown only if there are results */}
                                      {invisOpenDropDownState &&
                                        tempStateList.length > 0 && (
                                          <Dropdown.Menu
                                            show
                                            style={{
                                              position: "absolute",
                                              width: "100%",
                                              zIndex: 1,
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                              padding: 0,
                                            }}
                                          >
                                            {tempStateList.map(
                                              (item, index) => (
                                                <Dropdown.Item
                                                  key={index}
                                                  onClick={() =>
                                                    this.handleSelect(
                                                      item,
                                                      0,
                                                      1
                                                    )
                                                  }
                                                  // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                  style={{
                                                    whiteSpace: "normal",
                                                    height: "40px",
                                                    wordWrap: "break-word",
                                                    overflowWrap: "break-word",
                                                    cursor: "pointer",
                                                    transition: "none",
                                                    backgroundColor:
                                                      this.state
                                                        .invfocusedIndexState ===
                                                      index
                                                        ? "#744587"
                                                        : "transparent",
                                                    color:
                                                      this.state
                                                        .invfocusedIndexState ===
                                                      index
                                                        ? "white"
                                                        : "black",
                                                  }}
                                                  onMouseEnter={() =>
                                                    this.handleHover(
                                                      index,
                                                      0,
                                                      1
                                                    )
                                                  }
                                                >
                                                  {item.Description}
                                                </Dropdown.Item>
                                              )
                                            )}
                                          </Dropdown.Menu>
                                        )}
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invregstateErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Key Contact Person
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      {isOtherPreName && (
                                        <input
                                          disabled={
                                            sameAsCorrespondence ||
                                            (sessionStorage.getItem(
                                              "RoleIDSS"
                                            ) == 5
                                              ? true
                                              : viewMode)
                                          }
                                          type="text"
                                          className="form-control-1"
                                          // maxLength={'40'}/
                                          value={otherName}
                                          onChange={(e) =>
                                            this.setState({
                                              otherName: e.target.value,
                                            })
                                          }
                                          placeholder={"Other"}
                                          style={{
                                            position: "absolute",
                                            display: !isOtherPreName && "none",
                                            paddingLeft: "5px",
                                            width: "45px",
                                            top: "60px",
                                          }}
                                          maxLength={20}
                                        />
                                      )}
                                      <div className="col-md-1">
                                        <div
                                          className="form-group"
                                          style={{
                                            width: 45,
                                            position: "absolute",
                                            left: 0,
                                            zIndex: 1,
                                            top: "28px",
                                            fontSize: "12px",
                                          }}
                                        >
                                          <label />
                                          <select
                                            className="form-control-1 select2 select-hidden-accessible"
                                            id="validationCustom03"
                                            required=""
                                            disabled={
                                              sameAsCorrespondence ||
                                              (sessionStorage.getItem(
                                                "RoleIDSS"
                                              ) == 5
                                                ? true
                                                : viewMode)
                                            }
                                            style={{
                                              borderTop: "none",
                                              borderBottom: "none",
                                              marginTop: 2,
                                              borderRadius: 0,
                                              borderLeft: 0,
                                              height: 33,
                                              padding: 0,
                                              color: "grey",
                                              background: "none",
                                            }}
                                            value={prename}
                                            onChange={(e) =>
                                              this.setState({
                                                prename: e.target.value,
                                                isOtherPreName:
                                                  e.target.value == "Other" &&
                                                  true,
                                              })
                                            }
                                          >
                                            <option value="Mr">Mr</option>
                                            <option value="Ms">Ms</option>
                                            <option value="DR">DR</option>
                                            <option value="Prof">Prof</option>
                                            <option value="Other">Other</option>
                                          </select>
                                        </div>
                                      </div>
                                      <input
                                        maxLength={200}
                                        disabled={
                                          sameAsCorrespondence ||
                                          (sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode)
                                        }
                                        type="text"
                                        class="form-control"
                                        placeholder="Contact Person"
                                        style={{
                                          position: "relative",
                                          paddingLeft: 55,
                                        }}
                                        value={invcontactPerson}
                                        onChange={(e) =>
                                          this.setState({
                                            invcontactPerson: e.target.value,
                                            invcontactPersonErr: "",
                                          })
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invcontactPersonErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Position/Title/Designation
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        maxLength={100}
                                        disabled={
                                          sameAsCorrespondence ||
                                          (sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode)
                                        }
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter Company name"
                                        value={invdesignation}
                                        onChange={(e) =>
                                          this.setState({
                                            invdesignation: e.target.value,
                                            invdesignationErr: "",
                                          })
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invdesignationErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Email Id
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        maxLength={100}
                                        disabled={
                                          sameAsCorrespondence ||
                                          (sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode)
                                        }
                                        type="email"
                                        class="form-control"
                                        placeholder="Enter Email"
                                        value={invemailId}
                                        onChange={(e) =>
                                          this.setState({
                                            invemailId: e.target.value,
                                            invemailIdErr: "",
                                          })
                                        }
                                        onBlur={(e) =>
                                          this.onEmailInput(e.target.value, 1)
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invemailIdErr}
                                      </span>
                                    }
                                  </div>
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>
                                        Phone Number
                                        <span className="red-star text-danger">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        disabled={
                                          sameAsCorrespondence ||
                                          (sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode)
                                        }
                                        className="form-control-1"
                                        value={invprephone}
                                        placeholder="ISD"
                                        maxLength={"10"}
                                        onChange={(e) =>
                                          this.setState({
                                            invprephone: e.target.value,
                                          })
                                        }
                                        style={{
                                          width: 55,
                                          position: "absolute",
                                          // top: 30,
                                          textAlign: "center",
                                          padding: " 6px !important",
                                          paddingLeft:
                                            invprephone == "" ? 10 : 0,
                                          borderLeft: 0,
                                          borderTop: 0,
                                          background: "none",
                                          borderBottom: 0,
                                          height: 34,
                                          zIndex: invisOpenDropDownState
                                            ? 0
                                            : 10,
                                          color: "grey",
                                        }}
                                      />
                                      <input
                                        disabled={
                                          sameAsCorrespondence ||
                                          (sessionStorage.getItem("RoleIDSS") ==
                                          5
                                            ? true
                                            : viewMode)
                                        }
                                        type="number"
                                        class="form-control"
                                        placeholder="Enter Phone no"
                                        style={{
                                          position: "relative",
                                          paddingLeft: 65,
                                        }}
                                        maxLength={
                                          countryId == 91 ? "10" : "11"
                                        }
                                        onInput={(e) =>
                                          this.maxLengthCheck(e, 10)
                                        }
                                        onKeyDown={(e) => this.preventMinus(e)}
                                        onPaste={(e) => this.handlePaste(e)}
                                        onWheel={(e) => e.target.blur()}
                                        value={invphone}
                                        onChange={(e) =>
                                          this.setState({
                                            invphone: e.target.value,
                                            invphoneErr: "",
                                          })
                                        }
                                      />
                                    </div>
                                    {
                                      <span className="text-danger text-start text-left d-block  ml-2">
                                        {invphoneErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </fieldset>
                          <fieldset>
                            <legend className="mb-0 pb-0">
                              Business Sector
                            </legend>
                            <div class="business_sector_grid">
                              {businessList?.length > 0 &&
                                businessList?.map((item) => (
                                  <div class="form-group">
                                    <div
                                      class="custom-control custom-checkbox"
                                      onClick={() => {
                                        if (
                                          !(sessionStorage.getItem(
                                            "RoleIDSS"
                                          ) == 5
                                            ? true
                                            : viewMode)
                                        ) {
                                          this.onbusinessSelect(item.Code);
                                        }
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        checked={item.isSelect}
                                        value={item.isSelect}
                                      />
                                      <label class="custom-control-label">
                                        {item.Description}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </fieldset>
                          {/* <fieldset>
                                                        <legend>Primary Products/Services<span className="red-star text-danger">*</span></legend>

                                                        <div class="business_sector_grid">
                                                            {productsList?.length > 0 && productsList?.map(item => (
                                                                <div class="form-group">
                                                                    <div class="custom-control custom-checkbox" onClick={(e) => { if (!viewMode) { this.onProductSelect(item.Code) } }} >
                                                                        <input type="checkbox" class="custom-control-input" checked={item.isSelect} value={item.isSelect} />
                                                                        <label class="custom-control-label" >{item.Description}</label>
                                                                    </div>
                                                                </div>
                                                            ))}

                                                        </div>
                                                        {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.primaryProductsErr}</span>}
                                                    </fieldset> */}
                          <fieldset>
                            <legend className="mb-0 pb-0">
                              Key Export Markets
                            </legend>

                            <div class="business_sector_grid">
                              {exportsList?.length > 0 &&
                                exportsList?.map((item) => (
                                  <div class="form-group">
                                    <div
                                      class="custom-control custom-checkbox"
                                      onClick={() => {
                                        if (
                                          !(sessionStorage.getItem(
                                            "RoleIDSS"
                                          ) == 5
                                            ? true
                                            : viewMode)
                                        ) {
                                          this.onExportsSelect(item.Code);
                                        }
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        checked={item.isSelect}
                                        value={item.isSelect}
                                      />
                                      <label class="custom-control-label">
                                        {item.Description}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </fieldset>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label>
                                  Primary Products/Services
                                  <span className="red-star text-danger">
                                    *
                                  </span>
                                </label>
                                <input
                                  value={primaryProduct}
                                  disabled={
                                    sessionStorage.getItem("RoleIDSS") == 5
                                      ? true
                                      : viewMode
                                  }
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter Primary Products/Services"
                                  maxLength={200}
                                  onChange={(e) =>
                                    this.setState({
                                      primaryProduct: e.target.value,
                                      primaryProductsErr: "",
                                    })
                                  }
                                />
                                {
                                  <span className="text-danger text-start text-left d-block  ml-2">
                                    {primaryProductsErr}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label>Annual Revenue</label>
                                <input
                                  value={annualRevenue}
                                  disabled={
                                    sessionStorage.getItem("RoleIDSS") == 5
                                      ? true
                                      : viewMode
                                  }
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter Annual Revenue"
                                  maxLength={20}
                                  onChange={(e) =>
                                    this.setState({
                                      annualRevenue: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          {parseInt(countryId) == 91 && (
                            <div class="row mt-3">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label class="floating-label">
                                    Upload Documents
                                    {parseInt(countryId) == 91 && (
                                      <span className="red-star text-danger">
                                        *
                                      </span>
                                    )}{" "}
                                    (Maximum 5mb / File Type .jpg, .jpeg, .png,
                                    .pdf)
                                  </label>
                                  {documentsList.length > 0 &&
                                    documentsList.map((item, index) => (
                                      <div class="after-add-more2">
                                        <div class="Add_more_div">
                                          <div class="select_doc_type">
                                            <select
                                              onChange={(e) =>
                                                this.onDocTypeSelect(
                                                  index,
                                                  e.target.value
                                                )
                                              }
                                              value={item.docId}
                                              class="form-control customSelect floating-control select2"
                                              id="fin_details_doc_upload"
                                              disabled={
                                                parseInt(countryId) == 91
                                              }
                                            >
                                              <option value="Select">
                                                Select Document Type
                                              </option>
                                              {docTypeList.length > 0 &&
                                                docTypeList.map((element) => (
                                                  <option value={element.Code}>
                                                    {element.Description}
                                                  </option>
                                                ))}
                                            </select>
                                          </div>
                                          {item.docId != 3 &&
                                            item.docId != "" && (
                                              <div class="img_upload_div">
                                                <input
                                                  type="text"
                                                  disabled={
                                                    sessionStorage.getItem(
                                                      "RoleIDSS"
                                                    ) == 5
                                                      ? true
                                                      : viewMode
                                                  }
                                                  onChange={(e) =>
                                                    this.onDocNoEnter(
                                                      index,
                                                      e.target.value,
                                                      item.docId
                                                    )
                                                  }
                                                  class="form-control"
                                                  value={item.no}
                                                  placeholder={`${item.type}*`}
                                                />
                                                {item.docId == 1 && (
                                                  <span className="text-danger text-start text-left d-block  ml-2">
                                                    {this.state.GstNoErr}
                                                  </span>
                                                )}
                                                {item.docId == 2 && (
                                                  <span className="text-danger text-start text-left d-block  ml-2">
                                                    {this.state.PanNoErr}
                                                  </span>
                                                )}
                                              </div>
                                            )}
                                          {item.filePath == "" ||
                                          item.filePath == null ? (
                                            <div class="img_upload_div">
                                              <input
                                                type="file"
                                                disabled={
                                                  sessionStorage.getItem(
                                                    "RoleIDSS"
                                                  ) == 5
                                                    ? true
                                                    : viewMode
                                                }
                                                onChange={(e) =>
                                                  this.onFilePick(
                                                    e,
                                                    e.target.files,
                                                    index,
                                                    item.docId
                                                  )
                                                }
                                                class="form-control"
                                                id={`file${index}`}
                                                accept=".jpg, .jpeg, .png, .pdf"
                                              />
                                              {item.docId == 1 && (
                                                <span className="text-danger text-start text-left d-block  ml-2">
                                                  {this.state.GstdocErr}
                                                </span>
                                              )}
                                              {item.docId == 2 && (
                                                <span className="text-danger text-start text-left d-block  ml-2">
                                                  {this.state.PandocErr}
                                                </span>
                                              )}
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                border: "1px solid #ccc",
                                                padding: "2px 20px",
                                                // display: 'inline-flex',
                                                alignItems: "center",
                                                marginRight: "12px",
                                                maxWidth: "300px",
                                                height: "33px",
                                              }}
                                            >
                                              <span
                                                className="text-dark"
                                                style={{ marginRight: "10px" }}
                                              >
                                                {item.fileName}
                                              </span>
                                              {viewMode ? (
                                                <></>
                                              ) : (
                                                <>
                                                  <i
                                                    className="fa fa-times text-danger img-can"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      this.onCrossClick(
                                                        item.docId
                                                      )
                                                    }
                                                  ></i>
                                                </>
                                              )}
                                              {item.docId == 1 && (
                                                <span className="text-danger text-start text-left d-block  ml-2">
                                                  {this.state.GstdocErr}
                                                </span>
                                              )}
                                              {item.docId == 2 && (
                                                <span className="text-danger text-start text-left d-block  ml-2">
                                                  {this.state.PandocErr}
                                                </span>
                                              )}
                                            </div>
                                          )}
                                          {item.filePath != "" ||
                                          item.file != "" ? (
                                            <div class="preview_icon_div">
                                              {item.fileType != null &&
                                              item.fileType != "" ? (
                                                <a
                                                  // href={item.filePath}
                                                  // target="_blank"
                                                  // rel="noopener noreferrer"
                                                  onClick={() =>
                                                    this.openImageInNewWindow(
                                                      `${item.file}`
                                                    )
                                                  }
                                                  class="preview load_document_icon"
                                                  title="View"
                                                >
                                                  <i class="fa fa-eye"></i>
                                                </a>
                                              ) : (
                                                <a
                                                  href={item.filePath}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  class="preview load_document_icon"
                                                  title="View"
                                                >
                                                  <i class="fa fa-eye"></i>
                                                </a>
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          {console.log(
                                            item.file,
                                            "item.file",
                                            item.filePath
                                          )}
                                          {parseInt(countryId) != 91 &&
                                            (index == 0 ? (
                                              documentsList.length <= 2 && (
                                                <div class="plus_icon_div change2">
                                                  <button
                                                    class="add-more2 load_document_icon"
                                                    onClick={() =>
                                                      this.onAddRow()
                                                    }
                                                  >
                                                    <i class="fa fa-plus"></i>
                                                  </button>
                                                </div>
                                              )
                                            ) : (
                                              <div class="plus_icon_div change2">
                                                <button
                                                  class="action_btn remove2 fa fa-trash"
                                                  onClick={() =>
                                                    this.onDelRow(index)
                                                  }
                                                ></button>
                                              </div>
                                            ))}
                                        </div>
                                      </div>
                                    ))}
                                  {
                                    <span className="text-danger text-start text-left d-block  ml-2">
                                      {this.state.docsErr}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                          )}

                          <div class="row">
                            <div class="col-md-12 text-right">
                              <>
                                <button
                                  class="btn btn-primary next_btn mx-2"
                                  onClick={() => this.navigateBackUserList()}
                                >
                                  Back
                                </button>
                                {sessionStorage.getItem("RoleIDSS") == 5 ? (
                                  <button
                                    class="btn btn-primary next_btn"
                                    onClick={() => this.updateMemberDetail()}
                                  >
                                    Update
                                  </button>
                                ) : (
                                  !viewMode && (
                                    <button
                                      class="btn btn-primary next_btn"
                                      onClick={() => this.updateMemberDetail()}
                                    >
                                      Submit
                                    </button>
                                  )
                                )}
                              </>

                              {/* <a id="move_to_tab_2"></a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Modal show={isOpen} onHide={() => this.setState({ isOpen: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p class="pop_label">Do you really want to delete this Document?</p>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              class="btn btn-success"
              onClick={(e) => this.handleDeleteDocument(e)}
            >
              Yes
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              style={{ marginLeft: "5px" }}
              onClick={() => this.setState({ isOpen: false, docDeleteID: "" })}
            >
              No
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    get_userDetails_action,
    updateMemberDetails_action,
    deleteRegistrationDocument_action,
    checkAvailableUsername_action,
  })(userDetails)
);
